import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import React, { useRef, useState } from 'react';
import { SVGAsset } from 'res';
import "./styles.css";
/**
 * @function UITextArea 
 * @param {STRING} label - Pass the textarea label as a string to the component.
 * @param {STRING} placeholder - Pass the textarea placeholder as a string to the component.
 * @param {STRING} resizerClassName - Pass a blank string to show resizer 
 * @returns {React.Component}
 * @example
 * <UITextArea label="Some label" />
 */
export default function UITextArea(props) {
    const label = props.label ?? "Add note to self (optional)";
    const placeholder = props.placeholder ?? "Type here...";
    const resizerClassName = props.resizerClassName ?? "hide";
    const [ textAreaValue, setTextAreaValue ] = useState(props.value ?? "");
    const [characterCount, setCharacterCount] = useState(0);
    const inputField = useRef();
    const textareaDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Textarea" } : {};
    const saveIconDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Save_Icon" } : {};

    const onChange = evt => {
      setTextAreaValue(inputField.current.value);
      setCharacterCount(inputField.current.value.length);

      if(props.onChange instanceof Function) {
        props.onChange(inputField.current.value, evt, inputField.current);
      }
    };

  return (
    <div className="ui-text-area">
        <div className="text-area-container flex-container flex-vertical align-center">
            <div className="flex-width label-container">
                <span className="label"><b>{label}</b></span>
            </div>
            <div className="flex-width text-area-wrapper">
                <textarea ref={ inputField } className="text-area" value={ textAreaValue }
                maxLength={ 255 } cols="30" rows="10" placeholder={placeholder}
                onChange={ onChange } { ...textareaDataPoint }></textarea>
                {/* this is needed for the resize grabber to work */}
                <div className={resizerClassName + " resizer-container"}>
                    <div className="resizer"></div>
                </div>
            </div>
            <div className="flex-width">
                <div className="flex-container flex-horizontal align-center">
                    <DisabledPrompt>
                        <div className="flex-width flex-container align-center clickable">
                            <SVGAsset id="SaveIcon" className="save-icon blue-icon" />
                            <span className="save-text blue-text" { ...saveIconDataPoint }>Save</span>
                        </div>
                    </DisabledPrompt>
                    
                    <div className="flex-width text-right">
                        <span className="gray-text">{characterCount}/255</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
  )
}
